import queryString from 'query-string';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from 'components/Box/Box';
import { Hide } from 'components/Hide';
import { Icon } from 'components/Icon';
import { Link, TrackedLink } from 'components/Link';
import { IdealistLogo } from 'components/Logo/IdealistLogo';
import { Text } from 'components/Text/Text';
import { gutterWidth } from 'theme/theme';

import {
  AmpPageHeaderBox,
  AmpPageHeaderLoginLink,
  AmpPageHeaderNavLinksBox,
  AmpPageHeaderSeparator,
} from './AmpPageHeader.styled';
import { AMP_PAGE_HEADER_NAV } from './AmpPageHeaderConstants';
import { AmpPageHeaderMainLink } from './Link/AmpPageHeaderMainLink';

export function AmpPageHeader() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const redirectTo = location ? `${location.pathname}${location.search}` : '';
  const redirectParam = queryString.stringify({ to: redirectTo });

  const nonAmpUrl = location.pathname.replace('/amp/', '/').replace(/#.+$/, '');

  return (
    <AmpPageHeaderBox position="relative">
      <Box
        classes={['flex', 'align-center', 'justify-between']}
        position={['fixed', null, null, 'relative']}
        top={0}
        left={0}
        width={1}
        height={[60, null, null, 72]}
        px={gutterWidth / 2}
        bg="white"
        boxShadow={['0 2px 4px rgba(0,0,0,0.075)', null, null, 'none']}
      >
        <Box mr={24} flex="0 0 auto">
          <TrackedLink
            href="/"
            title="Idealist"
            eventName="Idealist Logo Header"
            data-qa-id="header-logo-link"
          >
            <div style={{ lineHeight: 0 }}>
              <IdealistLogo withText height={{ mobile: 28, desktop: 36 }} />
            </div>
          </TrackedLink>
        </Box>

        <Hide lg xl>
          <Box ml="auto" classes={['flex', 'align-center']}>
            <a
              href={`${nonAmpUrl}#search`}
              aria-label={getText('Toggle search')}
              title={getText('Toggle search')}
              data-qa-id="search-menu-button"
            >
              <Icon name="search" size={22} colorName="darkContentGrey" />
            </a>

            <Box
              component="a"
              href={`${nonAmpUrl}#menu`}
              aria-label={getText('Toggle menu')}
              title={getText('Toggle menu')}
              ml={16}
              data-qa-id="mobile-menu-button"
            >
              <Icon name="hamburger" size={22} colorName="darkContentGrey" />
            </Box>
          </Box>
        </Hide>

        <AmpPageHeaderNavLinksBox
          flex="1 1 auto"
          $menuOpen={menuOpen}
          onClick={() => setMenuOpen(false)}
          height={[null, null, null, '100%']}
        >
          <Box
            display={['block', null, null, 'flex']}
            height={[null, null, null, '100%']}
            justifyContent="space-between"
            p={[gutterWidth / 2, null, null, 0]}
            pb={[0, null, null, 0]}
            data-qa-id="nav-dropdown-mobile"
          >
            <Box
              display={['block', null, null, 'flex']}
              alignItems="center"
              mt="1px"
            >
              {AMP_PAGE_HEADER_NAV.map((navOption, index) => (
                <AmpPageHeaderMainLink
                  key={navOption}
                  index={index}
                  navOption={navOption}
                />
              ))}
            </Box>

            <Box display={['block', null, null, 'flex']} alignItems="center">
              <Box display={['none', null, null, 'flex']} alignItems="center">
                <AmpPageHeaderLoginLink
                  href={`/login?${redirectParam}`}
                  data-qa-id="login-link"
                  aria-label={getText('Log In')}
                >
                  {getText('Log In')}
                </AmpPageHeaderLoginLink>
                <AmpPageHeaderSeparator style={{ marginLeft: 12 }} />
              </Box>

              <Hide xs sm md>
                <Box
                  component={AmpPageHeaderLoginLink}
                  mx={12}
                  classes={['flex', 'align-center']}
                  href={`${nonAmpUrl}#search`}
                  aria-label={getText('Toggle search')}
                  title={getText('Toggle search')}
                  data-qa-id="search-menu-button"
                >
                  <Box mr="6px">
                    <Icon name="search" size={18} />
                  </Box>
                  {getText('Search')}
                </Box>
              </Hide>

              <Hide xs sm md>
                <AmpPageHeaderSeparator />
              </Hide>

              <Hide xs sm md>
                <AmpPageHeaderSeparator style={{ marginRight: 12 }} />
              </Hide>

              <Link href="/post-a-listing">
                <Box classes={['flex', 'align-center']}>
                  <Box mr={[14, null, null, '4px']} mt="1px" opacity={0.8}>
                    <Icon name="pin" size={18} />
                  </Box>
                  <Text fontSize="inherit">{getText('Post a Listing')}</Text>
                </Box>
              </Link>
            </Box>
          </Box>
        </AmpPageHeaderNavLinksBox>
      </Box>
    </AmpPageHeaderBox>
  );
}
